import axios from 'axios'
import { Message } from 'element-ui'
import store from '../store'
import jsCookie from 'js-cookie'
import router from '../router'

// 创建axios实例
const service = axios.create({
  // baseURL: 'http://192.168.0.52:8180',
  baseURL: '/api/front-web-app/', //打包正式需要换成这个 连接测试服务地址也需要这个
  //baseURL: 'https://www.zyecp.com/api/front-web-app/',//本地直接连接正式试一下
  //baseURL: '/api',//连接同事电脑的ip需要打开这个
  timeout: 150000, // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  (config) => {
    // if (store.getters.token) {
    //     config.headers['Authorization'] = getToken()
    // }

    // let token = sessionStorage.getItem('Authorization')
    let token = jsCookie.get('Authorization')
    if (!config.headers.hasOwnProperty('Authorization') && token) {
      config.headers.token = token
    }

    return config
  },
  (error) => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  },
)

// respone拦截器
service.interceptors.response.use(
  (response) => {
    /**
     * code为非200是抛错 可结合自己业务进行修改
     */
    const res = response.data
    console.log('响应')
    console.log(res)
    if (res.errorCode && res.errorCode == '401') {
      console.log('自动退出401')
      store.commit('changeWsMemberId', '')
      jsCookie.set('wsmemberId', '')
      store.commit('changeLogin', 0)
      store.commit('changeLogintwo', { Authorization: '' })
      //清除比价数据
      localStorage.removeItem('contrastgoods')
      if (localStorage.getItem('shenpiliu')) {
        localStorage.removeItem('shenpiliu')
      } //清除是否打开在线客服 弹出框
      localStorage.removeItem('onlineDialog')
      store.commit('changeIsMessage', 0)
      router.push({
        path: '/login',
      })

      return Promise.reject('error')
    } else {
      return response.data
    }
    // console.log(res.code)
    // if (res.code !== '00') {
    //     Message({
    //         message: res.message,
    //         type: 'error',
    //         duration: 3 * 1000
    //     })

    //     return Promise.reject('error')
    // } else {
    //     return response.data
    // }
  },
  (error) => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000,
    })
    return Promise.reject(error)
  },
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js